import { render, staticRenderFns } from "./TicketDiscountPolicy.vue?vue&type=template&id=3f51fbf8"
import script from "./TicketDiscountPolicy.vue?vue&type=script&lang=js"
export * from "./TicketDiscountPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports